/*
 * Formats a number with thousand separators.
 * If the number is a single digit (0-9), it returns a string with a leading zero.
 * @param {number} num - The number to format.
 * @returns {string} - The formatted number as a string.
 */
export function formatNumber(num: number): string {
  if (num >= 0 && num < 10) {
    return `0${num}`;
  }
  return new Intl.NumberFormat().format(num);
}

export function formatNumberWithCommas(num: number | undefined | string | null): string {
  if (num === undefined || num === null) return '0';
  if (typeof num === 'string') {
    return new Intl.NumberFormat().format(Number(num));
  }
  return new Intl.NumberFormat().format(num);
}

export function formatUSDTwoDecimal(value: string | number | undefined | null): string {
  const num = Number(value);
  const safeValue = isNaN(num) ? 0 : num;

  return `$${safeValue.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
